module.exports = __webpack_public_path__ + "34736292/img/scraper-icon.df6ccde5.svg";